var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadSmallGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53685 13.2633C8.8124 13.4871 9.20719 13.4871 9.48274 13.2633L13.1539 10.2805C13.4753 10.0193 13.5242 9.54691 13.263 9.22543C13.0018 8.90395 12.5295 8.85509 12.208 9.11629L9.75979 11.1054L9.75979 0.75C9.75979 0.335787 9.42401 0 9.00979 0C8.59558 0 8.25979 0.335787 8.25979 0.75L8.25979 11.1054L5.81161 9.11629C5.49013 8.85509 5.01778 8.90395 4.75658 9.22543C4.49538 9.54691 4.54424 10.0193 4.86572 10.2805L8.53685 13.2633ZM0.75 16.49C0.335786 16.49 0 16.8258 0 17.24C0 17.6542 0.335786 17.99 0.75 17.99H17.2701C17.6843 17.99 18.0201 17.6542 18.0201 17.24C18.0201 16.8258 17.6843 16.49 17.2701 16.49H0.75Z",
    fill: "#63666A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSmallGrey);
export default __webpack_public_path__ + "static/media/DownloadSmallGrey.0c1a0a3767212b3251fe57804821c6b8.svg";
export { ForwardRef as ReactComponent };